<template>
    <el-dialog :visible.sync="visible" :title="formData.name"  :close-on-click-modal="false" :close-on-press-escape="false" class="dv_update">
      <el-form :model="formData" ref="dynamicValidateForm" label-width="100px" class="demo-dynamic">
        <el-form-item>
          <el-input style="width: 80%" v-model="formData.mobilePhone"></el-input>
          <el-button type="primary" icon="el-icon-search" @click="createOpenUrl()">{{$t('txmis.bt.search')}}</el-button>
        </el-form-item>
        <el-form-item>
          <el-input style="width: 80%" v-model="formData.openUrl"></el-input>
          <el-button type="primary" icon="el-icon-document-copy"  class="copyCode" @click="copy('.copyCode')" :data-clipboard-text="formData.openUrl">{{$t('txmis.bt.copy')}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
</template>

<script>
  //table封装组件
  import URL from '@/views/newmis36/util/url'
  import Clipboard from 'clipboard'
  export default {
    name: 'list',
    methods: {
      open(){
          this.visible = true;
      },
      close(){
          this.visible = false;
      },
      createOpenUrl(){
          this.axios.get(URL.customerRelation.createOpenUrl+"?mobilePhone="+this.formData.mobilePhone).then(res => {
              console.log(res);
               if(res.code == 0) {
                   this.$set(this.formData, "openUrl", res.result);
               }else {
                   this.$message.error(res.message);
               }
          })
      },
      copy(val){
          let clipboard = new Clipboard(val);
          clipboard.on('success', e => {
              this.$message.success('suc');
              clipboard.destroy()
          });
          clipboard.on('error', e => {
              this.$message.error('fail');
              clipboard.destroy()
          });
      },
    },
    data () {
      return {
          formData:{name:window.$t('txmis.relationList.relationOpenUrl')},
          visible:false
      }
    }
  }
</script>
